// @flow

import type {OrderStatus} from './order-status'
import type {OrderItemType} from './order-item-type'

export type OrderItem = {
  id: ?number,
  orderItemType: ?OrderItemType,
  engravedIdString: string,
  tariffName: string,
  dateEffective: ?Date,
  orderStatus: ?OrderStatus,
}

const buildOrderItem = (): OrderItem => {
  return {
    id: null,
    orderItemType: null,
    engravedIdString: '',
    tariffName: '',
    dateEffective: null,
    orderStatus: null
  }
}

export {
  buildOrderItem
}



// WEBPACK FOOTER //
// ./src/types/order-item.js